import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';
import SelectroV2 from '@aha-app/selectro-v2';
import customElementBoolAttr from 'javascripts/util/customElementBoolAttr';
import $ from 'jquery';

const ExistingWhiteboardPickerModal = ({ whiteboardSelected }) => {
  const [whiteboardId, setWhiteboardId] = useState(null);

  const onSubmit = event => {
    event.preventDefault();

    if (!whiteboardId) return;

    whiteboardSelected(whiteboardId);
  };

  return (
    <form onSubmit={onSubmit} className='form-horizontal modal-form'>
      <aha-modal-header>Add existing whiteboard</aha-modal-header>
      <div className='modal-body center'>
        <div className='control-group'>
          <label className='control-label'>Select whiteboard</label>
          <div className='controls input-xxlarge'>
            <SelectroV2
              deferFetch
              type='single'
              usesServerSearch
              fetchSearchParam='q'
              fetchUrl='/search/pages.selectro?type=whiteboards&no_linked_pages=true'
              templates={{
                item: 'Selectro_v2.item.withRef',
                trigger: 'Selectro_v2.trigger.featureWithRef',
              }}
              text={{
                noneSelected: 'Choose whiteboard',
              }}
              custom={{
                doNotMatchTriggerHeight: true,
              }}
              searchFields={['ref', 'text']}
              callbacks={{
                select({ payload }) {
                  const whiteboardId = payload.item?.data?.whiteboard_id;

                  if (whiteboardId) {
                    setWhiteboardId(whiteboardId);
                  }
                },
              }}
            />
          </div>
        </div>
      </div>
      <aha-modal-footer>
        <aha-button
          slot='secondary_actions'
          onClick={() => whiteboardSelected(null)}
        >
          Cancel
        </aha-button>
        <aha-button
          kind='primary'
          type='submit'
          disabled={customElementBoolAttr(!whiteboardId)}
        >
          Add to document
        </aha-button>
      </aha-modal-footer>
    </form>
  );
};

export default async function chooseExistingWhiteboard() {
  const modalWindowEl = document.getElementById('modal-window');
  if (!modalWindowEl) throw new Error('No modal window element found');
  const modalWindow: any = $(modalWindowEl);

  const root = createRoot(modalWindowEl);

  return new Promise<RecordId | void>((resolve, reject) => {
    root.render(
      <ExistingWhiteboardPickerModal
        whiteboardSelected={whiteboardId => {
          root.unmount();
          modalWindow.modal('hide');
          resolve(whiteboardId);
        }}
      />
    );

    modalWindow.modal('show').addClass('modal-big');
    modalWindow.on('hidden', () => resolve());
  });
}
